// A receipt is created only after the service confirms a persisted company ID.
// It contains identity and lifecycle facts, never estimated assessment values.
export const getConfirmedCompanyReceipt = (response, submitted, segment, now = new Date().toISOString()) => {
  const company = response?.data;
  if (response?.success === false || !company?.id || !submitted?.tenantId) {
    throw new Error('The saved company could not be confirmed. Please refresh the company list before trying again.');
  }
  if (company.tenantId && company.tenantId !== submitted.tenantId) {
    throw new Error('The saved company account could not be confirmed.');
  }
  return {
    companyId: company.id,
    tenantId: submitted.tenantId,
    companyName: company.name || submitted.name,
    country: company.country || submitted.country || '',
    dnbCompanyId: company.dnbCompanyId || submitted.dnbCompanyId || '',
    requestedCreditLimit: company.requestedCreditLimit ?? submitted.requestedCreditLimit,
    segment,
    createdAt: company.createdAt || now,
    addedAt: now,
    underwritingStatus: company.underwritingStatus,
    underwritingInProgress: company.underwritingInProgress,
    underwritingStartedAt: company.underwritingStartedAt,
    underwritingDispatchStatus: company.underwritingDispatchStatus,
  };
};

// The synchronous gate covers clicks before React has rendered a disabled button.
export const createCompanyCreationGate = () => {
  let activeRequest = null;
  return {
    begin(scope) {
      if (activeRequest?.scope === scope) return null;
      activeRequest = { scope };
      return activeRequest;
    },
    isCurrent(request, scope) {
      return Boolean(request && activeRequest === request && request.scope === scope);
    },
    finish(request) {
      if (activeRequest === request) activeRequest = null;
    },
  };
};
